module.exports = "<rect x=\"0\" y=\"0\" width=\"20\" height=\"20\" style=\"fill:DeepPink;\" />\n"